export const versionProvider = {
  setVersion: (version: string) => {
    localStorage.setItem('version', version);
  },
  getVersion: () => {
    const version = localStorage.getItem('version');
    if (version) return version;
    return '';
  },
};
